import moment from '@/plugins/vue-moment.js';

export default class TemplateTimePeriodRangeData {
    constructor(attributes = {}) {
        this.from_day = attributes.from_day || 1;
        this.to_day = attributes.to_day || 1;
        this.from_time = attributes.from_time ? TemplateTimePeriodRangeData.parseTime(attributes.from_time) : null;
        this.to_time = attributes.to_time ? TemplateTimePeriodRangeData.parseTime(attributes.to_time) : null;
        this.break_time = attributes.break_time || 0;
    }

    static fromForm(attributes) {
        const rangeData = new TemplateTimePeriodRangeData();

        rangeData.from_day = attributes.from_day;
        rangeData.from_time = attributes.from_time;
        rangeData.to_day = attributes.to_day;
        rangeData.to_time = attributes.to_time;
        rangeData.break_time = attributes.break_time;

        return rangeData;
    }

    static parseTime(value) {
        return new Date(`01 Jan 1970 ${value}`);
    }

    get from_moment() {
        return moment().add(this.from_day, 'days').set({
            hour: this.from_time.getHours(),
            minute: this.from_time.getMinutes(),
            second: this.from_time.getSeconds(),
        });
    }

    get to_moment() {
        return moment().add(this.to_day, 'days').set({
            hour: this.to_time.getHours(),
            minute: this.to_time.getMinutes(),
            second: this.to_time.getSeconds(),
        });
    }

    toPayload(timezone) {
        return {
            from_day: this.from_day,
            from_time: moment(this.from_time?.toLocaleTimeString(), 'h:mm:ss A').tz(timezone.name).format('HH:mm:ss'),
            to_day: this.to_day,
            to_time: moment(this.to_time?.toLocaleTimeString(), 'h:mm:ss A').tz(timezone.name).format('HH:mm:ss'),
            break_time: this.break_time,
        };
    }

    toForm() {
        return {
            from_day: this.from_day,
            from_time: this.from_time,
            to_day: this.to_day,
            to_time: this.to_time,
            break_time: this.break_time,
        };
    }

    reset() {
        this.from_day = 1;
        this.from_time = null;
        this.to_day = 1;
        this.to_time = null;
        this.break_time = 0;
    }

    isValid() {
        return !!this.from_day && !!this.from_time && !!this.to_day && !!this.to_time;
    }

    timeToFormat(field, format = 'h:mm a') {
        return moment(this[field]).format(format);
    }

    isOverlapped(otherTimePeriods) {
        if (!this.isValid()) {
            return false;
        }

        return (
            otherTimePeriods
                .map(otherTimePeriod => {
                    if (!otherTimePeriod.isValid()) {
                        return false;
                    }

                    return (
                        (otherTimePeriod.from_moment.isSameOrAfter(this.from_moment) &&
                            otherTimePeriod.from_moment.isBefore(this.to_moment)) ||
                        (otherTimePeriod.to_moment.isAfter(this.from_moment) &&
                            otherTimePeriod.to_moment.isBefore(this.to_moment)) ||
                        (otherTimePeriod.from_moment.isSameOrBefore(this.from_moment) &&
                            otherTimePeriod.to_moment.isSameOrAfter(this.to_moment))
                    );
                })
                .filter(timePeriod => !!timePeriod).length > 0
        );
    }
}
